import classNames from "classnames";
import type { MouseEvent } from "react";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import Button from "@components/atoms/Button";
import Dim from "@components/atoms/Dim";
import Icon from "@components/atoms/Icon";
import LoadingIcon from "@components/atoms/LoadingIcon";

import useLayout from "@hooks/reducerHooks/useLayout";

import { IconName } from "@const/enum";

function Modal() {
  const { t } = useTranslation();

  const { modal, isModalOpen, closeModal, isLoginOpen, closeLoginModal } = useLayout();

  const showCancelButton = useMemo(() => Boolean(modal.cancelButton?.label), [modal.cancelButton]);

  const handleClose = useCallback(
    (e: React.MouseEvent) => {
      if (modal.isCaptcha) return;

      isModalOpen && closeModal();
      if (showCancelButton) {
        modal.cancelButton?.onClick?.(e);
      } else {
        modal.confirmButton?.onClick?.(e);
      }
      isLoginOpen && closeLoginModal();
    },
    [isModalOpen, closeModal, isLoginOpen, closeLoginModal],
  );

  return (
    <>
      <div
        className={classNames(
          "fixed left-1/2 top-1/2 z-40 flex w-mobileModal -translate-x-1/2 -translate-y-1/2 flex-col gap-5 rounded-2.5 border border-tuneGrey-200 bg-white p-5 text-center",
          !modal.isLarge ? "pc:w-1/4 pc:max-w-120" : "w-1/2 max-w-160",
          modal.isCaptcha && "min-w-96",
        )}
      >
        {/* 닫기 X 버튼 */}
        {modal.closeButton ? (
          <Button
            className="absolute right-5 top-5"
            onClick={handleClose}
            styleType="secondary"
            variant="containedIcon"
          >
            <Icon name={IconName.Close_100} />
          </Button>
        ) : null}

        {/* 모달 타이틀 */}
        {Boolean(modal.title) &&
          (modal.title === t("account.shipping.address.find") ? (
            <h2 className="flex">{modal.title}</h2>
          ) : (
            <h2 className="flex justify-center text-sm font-regular text-black">{modal.title}</h2>
          ))}

        {/* 모달 텍스트 */}
        {Boolean(modal.description) && <p className="mb-5 block whitespace-pre-wrap text-black">{modal.description}</p>}

        {/* 모달 콘텐츠 */}
        {modal.children}

        {/* 모달 액션 버튼*/}
        {!modal.hasButton && (
          <div className="flex justify-between gap-2.5">
            {showCancelButton ? (
              <Button
                className="w-full text-center"
                onClick={(e) => {
                  modal.cancelButton?.onClick?.(e);
                  closeModal();
                }}
                styleType="secondary"
                variant="contained"
              >
                <span className="w-full">{modal.cancelButton?.label}</span>
              </Button>
            ) : null}

            <Button
              className="w-full text-center"
              isLoading={modal.progress}
              onClick={(e) => {
                if (modal.progress) return;
                modal.confirmButton?.onClick?.(e);
                // closeModal();
              }}
              variant="contained"
            >
              <span className="w-full">{modal.confirmButton?.label || "Okay"}</span>
            </Button>
          </div>
        )}
      </div>
      <Dim
        onClick={(e: MouseEvent) => {
          handleClose(e);
        }}
      />
    </>
  );
}

export default Modal;
